<template>
  <div v-if="show || alreadyShown" :class="{ '!hidden': !show }">
    <slot> </slot>
  </div>
</template>

<script setup lang="ts">
const props = defineProps({
  show: Boolean
});

const alreadyShown = ref(false);

watch(
  () => props.show,
  show => {
    if (show) {
      alreadyShown.value = true;
    }
  }
);
</script>
